import { faStar } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@material-ui/core';
import { FavoriteBorder, StarBorder } from '@material-ui/icons';
import { IoMdPulse } from 'react-icons/io';
import React, { useEffect, useState } from 'react';
import { Timeline, TimelineEvent } from 'react-event-timeline';
import styled from 'styled-components';
import fiterAPI from '../../fiterAPI';
import { parseDateToExcelDate } from '../../utils/text-processor';
import HistoryItem from './HistoryItem';

const NoItensContainer = styled.div`
  width: 100%;
  padding: 60px;
  border-radius: 8px;
`;

const Container = styled.div`
  width: 100%;
  height: max-content;
  max-height: 800px;
  overflow-y: auto;
`;

export default function UserHistoryDisplay(props) {
  const { userId } = props;
  const [history, setHistory] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fiterAPI.fetchUserHistory(userId);
      setHistory(response);
    }
    fetchData();
  }, [userId]);
  return (
    <Container>
      {history.length > 0 ? (
        <Timeline>
          {history.map(event => (
            <TimelineEvent
              title={parseDateToExcelDate(event.createdAt)}
              createAt={parseDateToExcelDate(event.createdAt)}
              icon={<IoMdPulse />}
            >
              <HistoryItem event={event} />
            </TimelineEvent>
          ))}
        </Timeline>
      ) : (
        <NoItensContainer>
          Não foram encontrados eventos deste usuário.
        </NoItensContainer>
      )}
    </Container>
  );
}
